import React, { useState } from "react";
import { openModal, closeModal } from "../../store/slices/editModalSlice";
import { useDispatch, useSelector } from "react-redux";
import InfoModal from "../Modals/InfoModal";
import { openModalDelete } from "../../store/slices/deleteModalTextLiteratureSlice";
import DeleteModalTextLiterature from "../Modals/DeleteModal/DeleteModalTextLiterature";
import EditModalTextLiterature from "../Modals/EditModal/EditModalTextLiterature";
import { FiEye } from "react-icons/fi";
import { getLiteratureTextById } from "../../store/slices/apiLiteratureSlice";

const TableItemsTextLiteratureResponsive = ({
  dataTextLiterature,
  baseUrl,
}) => {
  const dispatch = useDispatch();
  const editModalState = useSelector((state) => state.editModalTextLiterature);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedTextId, setSelectedTextId] = useState(null);
  const selectedText = useSelector((state) => state.apiLiterature.dataText);

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const handleEditItem = (id) => {
    dispatch(openModal(id));
  };

  const handleDeleteItem = (id) => {
    dispatch(openModalDelete(id));
  };

  const handleViewText = async (id) => {
    setSelectedTextId(id);
    await dispatch(getLiteratureTextById(id));
    setIsViewModalOpen(true);
  };

  return (
    <>
      <div className="block sm:hidden space-y-4">
        {dataTextLiterature?.data?.map((item) => (
          <div
            key={item.id}
            className="bg-white shadow rounded-lg p-4 text-sm space-y-2"
          >
            <p>
              <strong>Titulli:</strong> {item.title}
            </p>
            <p>
              <strong>Teksti:</strong> {item.text}
            </p>
            <p>
              <strong>Literatura:</strong> {item.literature_name}
            </p>
            <p>
              <strong>Kategoria:</strong> {item.category_name}
            </p>
            <div>
              <strong>Ikona:</strong>
              <a
                href={`${baseUrl}/${item.icon}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={`${baseUrl}/${item.icon}`}
                  alt="Ikona"
                  className="w-14 h-14 object-cover mt-2"
                />
              </a>
            </div>
            <div className="flex flex-wrap gap-2 pt-2">
              <InfoModal
                title="Info rreth pyetjes"
                onCancel={handleCloseModal}
                name="Lloji i testit"
                categoryInInfo="Pyetja"
              />
              <EditModalTextLiterature
                id={item.id}
                title="Edito një tekst"
                submitButtonText="Edito tekstin"
                onCancel={handleCloseModal}
                titleContent={item.title}
                text={item.text}
                isOpen={editModalState[item.id] === true}
              />
              <DeleteModalTextLiterature
                id={item.id}
                onCancel={handleCloseModal}
              />
              <button
                className="text-sm"
                onClick={() => handleViewText(item.id)}
              >
                <FiEye
                  className="text-green-500 text-lg"
                  style={{ width: 23, height: 23 }}
                />
              </button>
            </div>
          </div>
        ))}
      </div>

      {isViewModalOpen &&
        Array.isArray(selectedText) &&
        selectedText.length > 0 && (
          <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-40">
            <div className="bg-white rounded-lg shadow-lg p-6 max-w-xl w-full max-h-[80vh] overflow-y-auto">
              <h2 className="text-xl font-bold mb-4 text-gray-800">
                {selectedText[0].title}
              </h2>
              <p className="text-gray-700 whitespace-pre-line">
                {selectedText[0].text}
              </p>
              <div className="mt-4 text-right">
                <button
                  onClick={() => setIsViewModalOpen(false)}
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                  Mbyll
                </button>
              </div>
            </div>
          </div>
        )}
    </>
  );
};

export default TableItemsTextLiteratureResponsive;
